module.exports = __webpack_public_path__ + "assets/img/Sedan-Gallery-image-4.80cbe52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/Sedan-Gallery/Sedan-Gallery-image-4.jpg
// module id = OeYG
// module chunks = 1